<div class="floating-contact">

    <a *ngIf="contact.enable.facebook" [href]="contact.facebook" target="_blank" class="item">
        <svg width="22" height="22" viewBox="0 0 24 24">
            <path fill="#1877F2" d="M22 12a10 10 0 10-11.6 9.9v-7H7.8V12h2.6V9.8c0-2.6 1.5-4.1 4-4.1
      1.2 0 2.4.2 2.4.2v2.6h-1.4c-1.4 0-1.8.9-1.8 1.8V12h3l-.5
      2.9h-2.5v7A10 10 0 0022 12z" />
        </svg>
        <span>{{ contact.labels.facebook }}</span>
    </a>

    <a *ngIf="contact.enable.zalo" [href]="contact.zalo" target="_blank" class="item">
        <svg width="22" height="22" viewBox="0 0 48 48">
            <path fill="#008FE5" d="M24 4C12.95 4 4 11.61 4 21c0 4.72 2.35 8.97 6.14
      12.02L8 44l10.2-5.3c1.9.5 3.88.77 5.8.77 11.05
      0 20-7.61 20-17S35.05 4 24 4z" />
            <text x="24" y="28" text-anchor="middle" font-size="14" fill="white" font-weight="bold">
                Zalo
            </text>
        </svg>
        <span>{{ contact.labels.zalo }}</span>
    </a>

    <a *ngIf="contact.enable.phone" [href]="'tel:' + contact.phone" class="item">
        <svg width="22" height="22" viewBox="0 0 24 24">
            <path fill="#4CAF50" d="M6.6 10.8c1.4 2.8 3.8 5.2 6.6
      6.6l2.2-2.2c.3-.3.7-.4
      1.1-.3 1.2.4 2.6.6 4 .6.6
      0 1 .4 1 1V21c0 .6-.4
      1-1 1C10.3 22 2 13.7 2
      3c0-.6.4-1 1-1h3.5c.6
      0 1 .4 1 1 0 1.4.2 2.8.6
      4 .1.4 0 .8-.3 1.1l-2.2
      2.7z" />
        </svg>
        <span>{{ contact.labels.phone }}</span>
    </a>

</div>